import HttpService from './commons/HttpService';

const ServiceCategoryService = {
  save(serviceCategory) {
    if (serviceCategory.id && serviceCategory.id > 0) {
      return this.update(serviceCategory);
    }
    return this.create(serviceCategory);
  },
  create(serviceCategory) {
    return HttpService.post('/serviceCategories', serviceCategory);
  },
  update(serviceCategory) {
    return HttpService.put(`/serviceCategories/${serviceCategory.id}`, serviceCategory);
  },
  delete(serviceCategory) {
    return HttpService.delete(`/serviceCategories/${serviceCategory.id}`);
  },
  getById(id) {
    return HttpService.get(`/serviceCategories/${id}`);
  },
  findAllForCurrentUser() {
    return HttpService.get('/serviceCategories');
  },
};

export default ServiceCategoryService;
